import { AuthnLevel } from '@oiambk/oiam-oauth-types';

export interface SessionTime {
  maxsessiontime: number;
  idletime: number;
  idlewarntime: number;
  authnLevel: AuthnLevel;
}

export class AuthnLevelTimes {
  private readonly MAXSESSIONHOCH: number = 1800000; // 30min
  private readonly IDLEHOCH: number = 300000; // 5min
  private readonly IDLEWARNHOCH: number = 60000; // 1min
  private readonly MAXSESSIONSUBSTANTIELL: number = 7200000; // 120min
  private readonly IDLESUBSTANTIELL: number = 1800000; // 30min
  private readonly IDLEWARNSUBSTANTIELL: number = 300000; // 5min
  private readonly MAXSESSIONNORMAL: number = 43200000; // 720min
  private readonly IDLENORMAL: number = 3600000; // 60min
  private readonly IDLEWARNNORMAL: number = 300000; // 5min

  private readonly _sessionTime: SessionTime;
  private _authnLevel: AuthnLevel;

  constructor(authnLevel: AuthnLevel) {
    this._authnLevel = authnLevel;
    this._sessionTime = this.sessionTimeMap.get(this._authnLevel);
  }

  private sessionTimeMap: Map<AuthnLevel, SessionTime> = new Map([
    [
      'STORK-QAA-Level-1',
      {
        maxsessiontime: this.MAXSESSIONNORMAL,
        idletime: this.IDLENORMAL,
        idlewarntime: this.IDLEWARNNORMAL,
        authnLevel: 'STORK-QAA-Level-1',
      },
    ],
    [
      'STORK-QAA-Level-2',
      {
        maxsessiontime: this.MAXSESSIONNORMAL,
        idletime: this.IDLENORMAL,
        idlewarntime: this.IDLEWARNNORMAL,
        authnLevel: 'STORK-QAA-Level-2',
      },
    ],
    [
      'STORK-QAA-Level-3',
      {
        maxsessiontime: this.MAXSESSIONSUBSTANTIELL,
        idletime: this.IDLESUBSTANTIELL,
        idlewarntime: this.IDLEWARNSUBSTANTIELL,
        authnLevel: 'STORK-QAA-Level-3',
      },
    ],
    [
      'STORK-QAA-Level-4',
      {
        maxsessiontime: this.MAXSESSIONHOCH,
        idletime: this.IDLEHOCH,
        idlewarntime: this.IDLEWARNHOCH,
        authnLevel: 'STORK-QAA-Level-4',
      },
    ],
  ]);

  get authnLevel(): AuthnLevel {
    return this._authnLevel;
  }

  get sessionTime(): SessionTime {
    return this._sessionTime;
  }
}
